import withStyles from '@material-ui/core/styles/withStyles';
import DeleteAccount from './DeleteAccount';
import { deleteAccountStyle } from './deleteAccount.style';
export default withStyles(deleteAccountStyle)(DeleteAccount);
//# sourceMappingURL=index.js.map